import styled from "styled-components";

export const Container = styled.div`
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  &:not(:last-child) {margin-bottom: 20px;}
`

export const Title = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 1.2;
`

export const SittingBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`